export const of_tariffs_import_locale = {
  SUCCESSFUL_IMPORTS: "Successful imports",
  FAILED_IMPORTS: "Failed imports",
  TARIFF_IMPORT_RESULTS: "Tariff import results",
  FINISH_IMPORT: "finish import"
};
